/* Rellision — email + international SMS signup */
(function () {
  var DIAL = [
    ['Netherlands','NL','31'],['Belgium','BE','32'],['Germany','DE','49'],['France','FR','33'],['United Kingdom','GB','44'],
    ['United States','US','1'],['Canada','CA','1'],['Ireland','IE','353'],['Spain','ES','34'],['Portugal','PT','351'],
    ['Italy','IT','39'],['Austria','AT','43'],['Switzerland','CH','41'],['Denmark','DK','45'],['Sweden','SE','46'],
    ['Norway','NO','47'],['Finland','FI','358'],['Iceland','IS','354'],['Poland','PL','48'],['Czechia','CZ','420'],
    ['Slovakia','SK','421'],['Hungary','HU','36'],['Romania','RO','40'],['Bulgaria','BG','359'],['Greece','GR','30'],
    ['Croatia','HR','385'],['Slovenia','SI','386'],['Serbia','RS','381'],['Bosnia and Herzegovina','BA','387'],
    ['North Macedonia','MK','389'],['Albania','AL','355'],['Montenegro','ME','382'],['Kosovo','XK','383'],
    ['Estonia','EE','372'],['Latvia','LV','371'],['Lithuania','LT','370'],['Belarus','BY','375'],['Ukraine','UA','380'],
    ['Moldova','MD','373'],['Russia','RU','7'],['Kazakhstan','KZ','7'],['Turkey','TR','90'],['Cyprus','CY','357'],
    ['Malta','MT','356'],['Luxembourg','LU','352'],['Monaco','MC','377'],['Andorra','AD','376'],['San Marino','SM','378'],
    ['Morocco','MA','212'],['Algeria','DZ','213'],['Tunisia','TN','216'],['Libya','LY','218'],['Egypt','EG','20'],
    ['Nigeria','NG','234'],['Ghana','GH','233'],['Senegal','SN','221'],['Ivory Coast','CI','225'],['Cameroon','CM','237'],
    ['Kenya','KE','254'],['Tanzania','TZ','255'],['Uganda','UG','256'],['Ethiopia','ET','251'],['Rwanda','RW','250'],
    ['South Africa','ZA','27'],['Zimbabwe','ZW','263'],['Zambia','ZM','260'],['Angola','AO','244'],['Mozambique','MZ','258'],
    ['Botswana','BW','267'],['Namibia','NA','264'],['Mauritius','MU','230'],['Cape Verde','CV','238'],
    ['Israel','IL','972'],['Lebanon','LB','961'],['Jordan','JO','962'],['Saudi Arabia','SA','966'],
    ['United Arab Emirates','AE','971'],['Qatar','QA','974'],['Kuwait','KW','965'],['Bahrain','BH','973'],['Oman','OM','968'],
    ['Iraq','IQ','964'],['Iran','IR','98'],['Georgia','GE','995'],['Armenia','AM','374'],['Azerbaijan','AZ','994'],
    ['Pakistan','PK','92'],['India','IN','91'],['Bangladesh','BD','880'],['Sri Lanka','LK','94'],['Nepal','NP','977'],
    ['China','CN','86'],['Hong Kong','HK','852'],['Taiwan','TW','886'],['Japan','JP','81'],['South Korea','KR','82'],
    ['Singapore','SG','65'],['Malaysia','MY','60'],['Indonesia','ID','62'],['Philippines','PH','63'],['Thailand','TH','66'],
    ['Vietnam','VN','84'],['Cambodia','KH','855'],['Myanmar','MM','95'],['Australia','AU','61'],['New Zealand','NZ','64'],
    ['Fiji','FJ','679'],['Papua New Guinea','PG','675'],
    ['Mexico','MX','52'],['Guatemala','GT','502'],['Costa Rica','CR','506'],['Panama','PA','507'],['Cuba','CU','53'],
    ['Dominican Republic','DO','1'],['Jamaica','JM','1'],['Trinidad and Tobago','TT','1'],['Puerto Rico','PR','1'],
    ['Curaçao','CW','599'],['Aruba','AW','297'],['Suriname','SR','597'],
    ['Brazil','BR','55'],['Argentina','AR','54'],['Chile','CL','56'],['Colombia','CO','57'],['Peru','PE','51'],
    ['Venezuela','VE','58'],['Ecuador','EC','593'],['Bolivia','BO','591'],['Uruguay','UY','598'],['Paraguay','PY','595']
  ];

  function flag(iso) {
    return iso.replace(/./g, function (ch) {
      return String.fromCodePoint(0x1F1E6 + ch.toUpperCase().charCodeAt(0) - 65);
    });
  }

  function fillCountries(sel, preferred) {
    var list = DIAL.slice().sort(function (a, b) { return a[0].localeCompare(b[0]); });
    sel.innerHTML = list.map(function (c) {
      return '<option value="' + c[2] + '" data-iso="' + c[1] + '" title="' + c[0] + '">' +
        flag(c[1]) + ' +' + c[2] + '</option>';
    }).join('');
    var want = (preferred || 'NL').toUpperCase();
    var hit = [].slice.call(sel.options).filter(function (o) { return o.dataset.iso === want; })[0];
    if (hit) sel.value = hit.value, sel.selectedIndex = hit.index;
  }

  /* to E.164: +<dial><national number, leading zeros stripped> */
  function e164(dial, raw) {
    var v = (raw || '').replace(/[^\d+]/g, '');
    if (v.indexOf('+') === 0) return v;
    if (v.indexOf('00') === 0) return '+' + v.slice(2);
    v = v.replace(/^0+/, '');
    if (!v) return '';
    return '+' + dial + v;
  }

  function subscribe(cfg, payload) {
    /* Klaviyo needs BOTH a public key and a list id — without either we stay in demo mode */
    if (!cfg.key || !cfg.list) return Promise.resolve({ ok: true, demo: true });
    var attrs = { email: payload.email };
    if (payload.phone) attrs.phone_number = payload.phone;
    attrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (payload.phone && payload.sms) attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: payload.source || 'Website',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) { return { ok: r.ok || r.status === 202, status: r.status }; })
      .catch(function () { return { ok: false, status: 0 }; });
  }

  function wire(form) {
    var cfg = { key: form.dataset.klaviyoKey || '', list: form.dataset.klaviyoList || '' };
    var email = form.querySelector('[data-sub-email]');
    var country = form.querySelector('[data-sub-country]');
    var phone = form.querySelector('[data-sub-phone]');
    var sms = form.querySelector('[data-sub-sms]');
    var note = form.querySelector('[data-sub-note]');
    var btn = form.querySelector('button[type="submit"]');
    if (country) fillCountries(country, form.dataset.country);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var mail = (email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { email.focus(); say('CHECK YOUR EMAIL ADDRESS', true); return; }
      var tel = phone ? e164(country ? country.value : '', phone.value) : '';
      if (tel && tel.replace(/\D/g, '').length < 8) { phone.focus(); say('CHECK YOUR PHONE NUMBER', true); return; }
      if (tel && sms && !sms.checked) { say('TICK THE SMS BOX OR LEAVE THE PHONE FIELD EMPTY', true); return; }

      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'SENDING…';
      subscribe(cfg, { email: mail, phone: tel, sms: sms ? sms.checked : false, source: form.dataset.source })
        .then(function (r) {
          btn.disabled = false; btn.textContent = label;
          if (!r.ok) return say('COULD NOT SUBSCRIBE (ERROR ' + (r.status || 'NETWORK') + ') — TRY AGAIN', true);
          form.reset();
          if (country) fillCountries(country, form.dataset.country);
          if (r.demo && form.dataset.warn === 'true') {
            console.warn('[Rellision] Klaviyo public key and list ID are not both set — signups are not being stored.');
          }
          say(form.dataset.thanks || 'THANK YOU — YOU ARE ON THE LIST', false);
        });
    });

    function say(msg, bad) {
      if (!note) return;
      note.textContent = msg;
      note.style.color = bad ? 'var(--red)' : 'var(--ink-3)';
    }
  }

  function init() { document.querySelectorAll('[data-subscribe]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
